import { render, staticRenderFns } from "./NewBorcluEditForm.vue?vue&type=template&id=72ddee84&scoped=true"
import script from "./NewBorcluEditForm.vue?vue&type=script&lang=ts"
export * from "./NewBorcluEditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ddee84",
  null
  
)

export default component.exports